import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../../context/global-data-provider';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import { PostLgReactionsContext } from '../../../context/post-lg-reactions-provider';
import { useMediaQuery } from 'react-responsive';
import RelatedPost from '../posts-list/related-posts';
import VideoPostItemLg from '../../components/posts/video-post-item-lg';
import LgCommentItem from '../../components/comment-item/lg-comment-item';
import LoadingInCenter from '../../components/loading/loading-in-center';
import ModalSharePost from '../../components/modal/modal-share-post';
import Svg from '../../components/icons/svg';
import LgFormAddComment from '../../components/form/lg-form-add-comment';
import Caroumal from '../../plugin/caroumal/caroumal';
import './post-lg-style.css';
import InfoCaption from '../../components/posts/info-caption';
import { BtnContactShop } from '../../components/btn-contact-shop';
import RestorePost from '../../components/actions/restore-post';

const DeletePost = React.lazy(() => import(/* webpackChunkName: "post-admin-actions" */ '../../components/actions/delete-post'));
const UpdatePost = React.lazy(() => import(/* webpackChunkName: "post-admin-actions" */ '../../components/actions/update-post'));

function PostLg() {
  const { post } = useContext(Context);
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);
  const [provider] = useContext(PostLgReactionsContext);
  const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });
  const isTablet = useMediaQuery({ query: '(max-width: 991px)' });

  const handleCommentButtonClick = () => {
    if (admin.auth.value || member.auth.value) {
      provider.inputRef.current.focus();
    } else {
      provider.setShowLoginRequired(true);
      provider.inputRef.current.blur();
    }
  };

  const handleCloseLoginRequired = () => {
    provider.setShowLoginRequired(false);
  };

  const handleSetRedirect = () => {
    member.setRedirect(`post/${post.data.id}`);
  };

  return (
    <React.Fragment>
      <div className="lg w-100 m-align-x align-items-center">
        <article className="post w-100">
          <div className="post-header f-row align-items-center justify-content-between">
            {post.data?.title?.length ? (
              post.data?.title
            ) : (
              <Link
                to={`/${post.data.gc ? 'gallery-' : ''}category/${
                  post.data.category.id + '/' + post.data.category.uniqTitle
                }`}
                className="d-inline-block font-size-5 color-main"
              >
                {post.data.category.title}
              </Link>
            )}
            <div className="actions f-row">
              {admin.auth.value && post.data.trash === '1' && <RestorePost id={post.data.id} />}
              {admin.auth.value && (
                <React.Suspense fallback={null}>
                  <UpdatePost />
                  <DeletePost id={post.data.id} />
                </React.Suspense>
              )}
            </div>
          </div>

          <div className="media justify-content-center">
            <div className="w-100 d-block">
              <div className="media-content o-hidden d-flex f-row">
                {post.data.media.length === 1 && SingleItem(post)}
                {post.data.media.length > 1 && Carousel(post, isDesktop, isTablet)}
                {post.data.version === 1 && (
                  <div className={'info-caption-wrapper'}>
                    {(post?.data?.shop ?? []).map((row, i) => {
                      return <InfoCaption {...row} lg key={row.id} />;
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="reactions bs-border-box">
            <div className="info f-grow-1 f-shrink-1">
              <ul className="bs-content-box f-grow-1">
                {post.data?.description?.length && (
                  <div className="description">
                    <li className="p-relative o-hidden ww-break-word">
                      <div>
                        <span className="font-size-5 line-height-3">
                          {post.data?.description &&
                            post.data.description.split('\n').map((str, i) => {
                              return (
                                <React.Fragment key={str + i}>
                                  {str}
                                  <br />
                                </React.Fragment>
                              );
                            })}
                        </span>
                      </div>
                    </li>
                  </div>
                )}

                {provider.newComments.list.map((comment) => {
                  return <LgCommentItem comment={comment} key={JSON.stringify(comment)} />;
                })}

                {provider.comments.list.map((comment) => {
                  return <LgCommentItem comment={comment} key={JSON.stringify(comment)} />;
                })}

                {provider.hasMore && (
                  <li>
                    <div className="p-relative f-00auto justify-content-center align-content-stretch align-content-stretch">
                      {provider.moreLoading ? (
                        <button
                          type="button"
                          className="p-0 d-flex justify-content-center align-items-center c-p f-grow-0 py-8p"
                          style={{ height: '40px' }}
                        >
                          <LoadingInCenter show={true} label={'Comment Loading'} fill={'#555555'} width={24} height={24} />
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="p-0 d-flex justify-content-center align-items-center c-p f-grow-0 py-8p"
                          onClick={provider.loadMoreComment}
                        >
                          <span className="glyphsSpriteCircle_add__outline__24__grey_9 d-block" />
                        </button>
                      )}
                    </div>
                  </li>
                )}
              </ul>
            </div>

            <section className="btns f-row align-content-center justify-content-between">
              <BtnContactShop shopData={post?.data?.shop} path={`post/${post.data.id}`} />

              <div className="f-row">
                <ModalSharePost path={`post/${post.data.id}`} />

                <button
                  className="d-flex align-items-center justify-content-center c-p p-8p ml-n8p"
                  onClick={handleCommentButtonClick}
                >
                  <div className="align-items-center justify-content-center">
                    <Svg name={'comment'} label={'Comment'} fill={'#262626'} width={24} height={24} />
                  </div>
                </button>
              </div>
            </section>

            <section className="comment-form f-shrink-0 justify-content-center">
              <LgFormAddComment />
            </section>
          </div>

          {provider.showLoginRequired && (
            <div className="alert-login-required align-content-stretch align-items-center justify-content-center">
              <div className="body align-items-center">
                <p className="mb-26p">برای ارسال نظر باید وارد حساب کاربری خود شوید</p>
                <div className="f-row w-100 justify-content-around">
                  <Link to={'/member/login'} className="btn-primary" onClick={handleSetRedirect}>
                    ورود به حساب
                  </Link>
                  <button type="button" className="text-danger c-p" onClick={handleCloseLoginRequired}>
                    بازگشت
                  </button>
                </div>
              </div>
            </div>
          )}
        </article>
      </div>

      <div className="mt-48p">
        <hr className="hr-1" />
      </div>

      <div className="d-block mt-6vh">
        <div className="mb-20p f-00auto justify-content-start align-items-stretch align-content-stretch">
          <div className="d-block font-size-5 color-light-1">
            مشاهده پست های بیشتر از &nbsp;
            <Link
              to={`/${post.data.gc ? 'gallery-' : ''}category/${
                post.data.category.id + '/' + post.data.category.uniqTitle
              }`}
              className="d-inline-block font-size-5 color-main"
            >
              {post.data.category.title}
            </Link>
          </div>
        </div>
        <div>
          <RelatedPost isGallery={post.data.gc} category={post.data.category.id} postId={post.data.id} />
        </div>
      </div>
    </React.Fragment>
  );
}

const SingleItem = (post) => {
  const split = post.data.media[0].split('.');
  return split[split.length - 1] === 'jpg' ? (
    <img src={post.data.media[0]} alt={post.data?.title} className="media-img" />
  ) : (
    <VideoPostItemLg src={post.data.media[0]} turn={0} />
  );
};

const Carousel = (post, isDesktop, isTablet) => {
  const onTranslate = (e) => {
    try {
      const items = e.target.childNodes[0].childNodes[0].childNodes;
      const totalPage = parseInt(e.item.count) - 1;
      const index = parseInt(e.item.index);
      if (index === 0) {
        const video = items[1].querySelector('video');
        if (video) {
          setTimeout(() => {
            video.currentTime = 0;
          }, 450);
          video.pause();
          const div = items[1].querySelector('div.media-control-caption');
          if (div) {
            div.classList.remove('hide-control');
          }
        }
      } else if (index === totalPage) {
        const video = items[index - 1].querySelector('video');
        if (video) {
          setTimeout(() => {
            video.currentTime = 0;
          }, 450);
          video.pause();
          const div = items[index - 1].querySelector('div.media-control-caption');
          if (div) {
            div.classList.remove('hide-control');
          }
        }
      } else {
        const video1 = items[index - 1].querySelector('video');
        const video2 = items[index + 1].querySelector('video');
        if (video1) {
          setTimeout(() => {
            video1.currentTime = 0;
          }, 450);
          video1.pause();
          const div = items[index - 1].querySelector('div.media-control-caption');
          if (div) {
            div.classList.remove('hide-control');
          }
        }
        if (video2) {
          setTimeout(() => {
            video2.currentTime = 0;
          }, 450);
          video2.pause();
          const div = items[index + 1].querySelector('div.media-control-caption');
          if (div) {
            div.classList.remove('hide-control');
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onTranslated = (e) => {
    try {
      const index = e.item.index;
      const items = e.target.childNodes[0].childNodes[0].childNodes;
      const video = items[index].querySelector('video');
      if (video) {
        video.play();
        const div = items[index].querySelector('div.media-control-caption');
        if (div) {
          div.classList.add('hide-control');
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <React.Fragment>
      {isDesktop && (
        <Caroumal
          onTranslate={onTranslate}
          onTranslated={onTranslated}
          className={'media-carousel'}
          id={'media-carousel'}
          items={1}
          autoWidth={false}
          rtl={true}
          arrows={true}
          dots={true}
          draggable={false}
          nextElement={
            <span
              className="caroumal-c-next coreSpritePagingChevron"
              aria-label="Next"
              style={{ transform: 'scale(-1)' }}
            />
          }
          prevElement={<span className="caroumal-c-next coreSpritePagingChevron" aria-label="Next" />}
        >
          {post.data.media.map((src, i) => {
            const split = src.split('.');
            return split[split.length - 1] === 'jpg' ? (
              <img src={src} alt={post.data?.title} className="media-img" key={src + i} />
            ) : (
              <VideoPostItemLg src={src} turn={i} key={src + i} />
            );
          })}
        </Caroumal>
      )}
      {isTablet && (
        <Caroumal
          onTranslate={onTranslate}
          onTranslated={onTranslated}
          className={'media-carousel'}
          id={'media-carousel'}
          items={1}
          autoWidth={false}
          rtl={true}
          arrows={true}
          dots={true}
          draggable={true}
          minMoveToToggle={5}
          nextElement={
            <span
              className="caroumal-c-next coreSpritePagingChevron"
              aria-label="Next"
              style={{ transform: 'scale(-1)' }}
            />
          }
          prevElement={<span className="caroumal-c-next coreSpritePagingChevron" aria-label="Next" />}
        >
          {post.data.media.map((src, i) => {
            const split = src.split('.');
            return split[split.length - 1] === 'jpg' ? (
              <img src={src} alt={post.data?.title} className="media-img" key={src + i} />
            ) : (
              <VideoPostItemLg src={src} turn={i} key={src + i} />
            );
          })}
        </Caroumal>
      )}
    </React.Fragment>
  );
};

export default PostLg;
